// Standard navigation-arrow glyph — the "Directions / navigate from here" mark
// used by map apps. Monochrome via currentColor so it matches the button text.
const NavigateIcon = ({ size = 16 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        style={{ display: "block" }}
    >
        <path d="M12 2 4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" />
    </svg>
);

export default NavigateIcon;
